import i18next from 'i18next';
import permissions from '../../config/permissions';
import { CUSTOM_TAGS_OPTIONS } from '../Shared/CustomTags';
import { CLAIM_REPORTS_STATUSES_OPTIONS } from '../ClaimReport/constants';
import { currencyFormat } from '../Shared/Table/helpers';
import { INFO_PANE_PAGES } from '../../redux_store/reducer/reducers/infoPaneReducer';
import FILTER_TYPES from '../Shared/Table/widgets/Filters/constants';

export const GET_REPORTABLES_COLUMNS = (isPatientPage = false) => [
  {
    size: 200,
    header: i18next.t('tables:customTags'),
    accessorKey: 'accountCustomTags',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: CUSTOM_TAGS_OPTIONS,
    },
    cell: {
      withBubbles: true,
    },
    permission: permissions.ACCOUNTS_GET,
  },
  {
    size: 220,
    header: i18next.t('tables:account'),
    accessorKey: 'accountBusinessName',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 180,
    header: i18next.t('tables:customId'),
    accessorKey: 'accountCustomIdentifier',
    filter: {},
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 240,
    header: i18next.t('tables:patientFirstName'),
    accessorKey: 'patientFirstName',
    filter: {},
    hidden: isPatientPage,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 240,
    header: i18next.t('tables:patientLastName'),
    accessorKey: 'patientLastName',
    filter: {},
    hidden: isPatientPage,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 190,
    header: i18next.t('tables:mrnNumber'),
    accessorKey: 'patientMrnNumber',
    filter: {},
    hidden: isPatientPage,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 180,
    header: i18next.t('tables:patientDOB'),
    accessorKey: 'patientDateOfBirth',
    filter: {
      filterType: FILTER_TYPES.DATE,
    },
    hidden: isPatientPage,
    isDefaultCell: true,
  },
  {
    size: 250,
    header: i18next.t('tables:entityName'),
    accessorKey: 'entityName',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:createdBy'),
    accessorKey: 'createdBy',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:modifiedBy'),
    accessorKey: 'modifiedBy',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    isDefaultCell: true,
  },
  {
    size: 300,
    header: i18next.t('tables:reportableGeneratedTimestamp'),
    accessorKey: 'reportableGeneratedTimestamp',
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:entityOrderTimestamp'),
    accessorKey: 'entityOrderTimestamp',
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 230,
    header: i18next.t('tables:entityCompletedTimestamp'),
    accessorKey: 'entityCompletedTimestamp',
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 250,
    header: i18next.t('tables:appointmentTimestamp'),
    accessorKey: 'appointmentTimestamp',
    filter: {
      shouldRange: true,
      hasNoMaxDate: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:paymentDate'),
    accessorKey: 'paymentDate',
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 180,
    header: i18next.t('tables:cptCode'),
    accessorKey: 'cptCode',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    isDefaultCell: true,
  },
  {
    size: 150,
    header: i18next.t('tables:price'),
    accessorKey: 'price',
    filter: {
      filterType: FILTER_TYPES.PRICE,
    },
    cell: {
      formattedFunction: currencyFormat,
    },
  },
  {
    size: 150,
    header: i18next.t('tables:paid'),
    accessorKey: 'paid',
    filter: {
      filterType: FILTER_TYPES.PRICE,
    },
    cell: {
      formattedFunction: currencyFormat,
    },
  },
  {
    size: 150,
    header: i18next.t('tables:icd'),
    accessorKey: 'icd',
    filter: {},
    isDefaultCell: true,
  },
  {
    size: 220,
    header: i18next.t('tables:reportStatus'),
    accessorKey: 'reportStatus',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: CLAIM_REPORTS_STATUSES_OPTIONS,
    },
    cell: {
      withBubble: true,
    },
  },
  {
    size: 160,
    header: i18next.t('tables:dos'),
    accessorKey: 'dos',
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
];
